import {z} from 'zod';

import {getCourseDocumentPath} from './course';

// ============================================================================
// Path segments
// ============================================================================

export const SECTION_SCHEDULE_SUBCOLLECTION = 'sectionSchedule' as const;
export const SECTION_SCHEDULE_DOCUMENT_ID = 'schedule' as const;

// ============================================================================
// Schema
// ============================================================================

export const SectionScheduleDocumentSchema = z
  .object({
    topics: z.array(z.string()).optional(),
  })
  .loose();

export type SectionScheduleDocument = z.infer<
  typeof SectionScheduleDocumentSchema
>;

// ============================================================================
// Paths
// ============================================================================

export function getSectionScheduleDocumentPath({
  courseId,
}: {
  courseId: string;
}): string {
  return `${getCourseDocumentPath({courseId})}/${SECTION_SCHEDULE_SUBCOLLECTION}/${SECTION_SCHEDULE_DOCUMENT_ID}`;
}
